module.exports = __webpack_public_path__ + "static/media/liam_french_canadian.426ddbbb.mp3";